import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { querySaga } from '../../../utils/reduxHelper';

function* resetSysApiLogsSaga() {
    yield put(appActions.APILOGS_RESET_SUCCESS());
}

function* watchSysApiLogsGetAllRequest() {
    yield takeLatest(
        appActions.APILOGS_GET_ALL_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                '/sys/vs-api-log',
                appActions.APILOGS_GET_ALL_SUCCESS,
                appActions.APILOGS_GET_ALL_FAILURE,
            );
        },
    );
}

export default function* sysApiLogsWatcher() {
    yield* watchSysApiLogsGetAllRequest();
    yield takeLatest(appActions.APILOGS_RESET_REQUEST.type,resetSysApiLogsSaga);
    // Add other watchers here
}
